import { MessageBox, Button } from '@ui5/webcomponents-react';
import { loginRequest } from 'auth/msalConfig';
import { useMsalAccountChecker } from 'auth/useMsalUtils';
import { useIdle } from 'hooks/useIdleTimer';
import { useTranslation } from 'react-i18next';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';

export const IdleMessageBox: React.FC = () => {
  const { t } = useTranslation();
  const { instance } = useMsalAccountChecker();
  const { isOpen, setIsOpen } = useIdle();

  const handleLogin = async () => {
    await instance.loginRedirect({
      ...loginRequest
    });
  };

  const getActions = () => {
    return [
      <Button
        id="idle-message-box-button-login"
        data-help-id="idle-message-box-button-login"
        key="idle-message-box-button-login"
        onClick={handleLogin}
        design={ButtonDesign.Emphasized}
      >
        {t('idle-message-box-button-login-content')}
      </Button>,
      <Button
        id="idle-message-box-button-close"
        key="idle-message-box-button-close"
        data-help-id="idle-message-box-button-close"
        onClick={() => setIsOpen(false)}
      >
        {t('idle-message-box-button-close-content')}
      </Button>
    ];
  };

  if (!isOpen) return null;

  return (
    <MessageBox
      data-testid="idle-message-box"
      titleText={t('idle-message-box-title')}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      actions={getActions()}
    >
      {t('idle-message-box-content')}
    </MessageBox>
  );
};
